import React from "react";

import { Box, Button, Grid, Typography } from "@mui/material";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";

import { VideosResponse } from "../types";
import Video from "../components/Video";
import { VideoSkeleton } from "./LoadingSkeletons";

interface VideoCardProps {
  isLoading: boolean;
  setModalOpen: (open: boolean) => void;
  data: VideosResponse;
  episodeId: string;
}

export function VideoCard({
  isLoading,
  setModalOpen,
  data,
  episodeId,
}: VideoCardProps) {
  const sortedVideos = [...(data?.videos || [])].sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
  );

  if (isLoading) {
    return <VideoSkeleton />;
  }

  return !sortedVideos.length ? (
    <Grid item xs={12}>
      <Box
        sx={{
          textAlign: "center",
          py: 8,
          px: 2,
        }}
      >
        <VideoLibraryIcon
          sx={{
            fontSize: 64,
            color: "text.secondary",
            mb: 2,
          }}
        />
        <Typography variant="h6" color="text.secondary" gutterBottom>
          No videos yet
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Create your first short video to get started
        </Typography>
        <Button
          variant="contained"
          onClick={() => setModalOpen(true)}
          size="large"
        >
          Create First Video
        </Button>
      </Box>
    </Grid>
  ) : (
    <>
      {sortedVideos.map((video) => (
        <Video key={video?.id} episodeId={episodeId || ""} video={video} />
      ))}
    </>
  );
}
